import get from 'lodash/get';
import types from '../types';
import getErrorMessage from '../utils/getErrorMessage';
import { showToast } from './Toast';

const getGeneric = payload => {
  return {
    type: types.api.FETCH_NUDGE,
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic',
      queryParams: { qid: payload.hotelId },
      method: 'POST',
      body: payload.requestBody
    },
    onSuccess: ({ data }) => {
      const response = get(data, 'data', {});
      payload.onSuccess(response);
    },
    onError: ({ error, store }) => {
      store.dispatch(showToast({ message: getErrorMessage(error) }));
      payload.onError();
    }
  };
};

export default getGeneric;
